import type { PropsWithChildren } from 'react';
import { createContext } from 'react';
import type { BaseConfigType } from '../types/base';

type ConfigContextValue<T extends BaseConfigType> = {
  config: T;
};

export const ConfigurationContext = createContext<ConfigContextValue<BaseConfigType> | null>(null);

type ConfigProviderProps<T extends BaseConfigType> = PropsWithChildren<{
  config: T;
}>;

export function ConfigProvider<T extends BaseConfigType>({ children, config }: ConfigProviderProps<T>) {
  return <ConfigurationContext.Provider value={{ config }}>{children}</ConfigurationContext.Provider>;
}
